/*
 *
 * EditTerminalPopup
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 3-Mar-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  confirm: <PortalMessage id='t.app.project.btn.confirm' defaultMessage='Confirm' />,
  titleManage: (
    <PortalMessage id='t.app.terminalsManagement.vasConfiguration.popup.title' defaultMessage='Manage the service' />
  ),
  status: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.status' defaultMessage='Status' />,
  description: {
    NetworkTokenization: (
      <PortalMessage
        id='t.app.terminalsManagement.vasConfiguration.description.TokenizationByCardScheme'
        defaultMessage='The Tokenization by card scheme service enables Mastercard cardholders to make payments through fortified transactions where card details are replaced by unique, encrypted tokens that keep information secure across every interaction..'
      />
    ),
    DynamicCurrencyConversion: (
      <PortalMessage
        id='t.app.terminalsManagement.vasConfiguration.description.DCC'
        defaultMessage='The DCC - Dynamic Currency Conversion service, enables international Visa and Mastercard cardholders to make payments in their home currency with a guaranteed exchange rate.'
      />
    ),
    TransactionRiskAnalysis: (
      <PortalMessage
        id='t.app.terminalsManagement.vasConfiguration.description.TRA'
        defaultMessage='The TRA - Transaction Risk Analysis service, analyzes card transactions in real time and enables exemption of strong customer authentication in allowed cases.'
      />
    ),
    PosTokenization: (
      <PortalMessage
        id='t.app.terminalsManagement.posTokenization.details.description'
        defaultMessage='Omnichannel service enabling creation of recurring payments contracts (tokenization) at physical POS terminals. Tokens can be used for debits and OneClick e-commerce payments.'
      />
    ),
    ClickNCollect: (
      <PortalMessage
        id='t.app.terminalsManagement.clickNCollect.details.description'
        defaultMessage='Omnichannel service enabling “Click & Collect” purchases, purchases initiated online that can be completed at a physical store.'
      />
    ),
    ClickToPay: (
      <PortalMessage
        id='t.app.terminalsManagement.vasConfiguration.description.ClickToPay'
        defaultMessage='Click to Pay simplifies online purchases with a faster and more secure checkout experience, without re-entering card details each time.'
      />
    )
  },
  info: {
    OMID: <PortalMessage id='t.app.terminalsManagement.vasConfiguration.info.OMID' defaultMessage='OMID' />,
    recurringGroup: (
      <PortalMessage
        id='t.app.terminalsManagement.vasConfiguration.info.recurringGroup'
        defaultMessage='Recurring Group'
      />
    )
  }
}

export const captions = defineMessages({
  ariaTitleManage: {
    id: 't.app.apmConfigurationModal.title',
    defaultMessage: 'Manage the service'
  },
  statusLabel_Enabled: { id: 't.app.terminalsManagement.vasConfiguration.status.enabled', defaultMessage: 'Enabled' },
  statusLabel_Disabled: {
    id: 't.app.terminalsManagement.vasConfiguration.status.disabled',
    defaultMessage: 'Disabled'
  },
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  }
})

export default formattedMessage
